import { combineReducers, configureStore } from '@reduxjs/toolkit';
import coursesReducer from './courseSlice';
import lessonReducer from './lessonSlice';
import authReducer from './authSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
    blacklist: ['lesson'],
};

const reducer = combineReducers({
    courses: coursesReducer,
    lesson: lessonReducer,
    auth: authReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export default store;
